import React from "react";
import {MeasurementUnitFormCreate} from "../../components/measurement-unit/form/MeasurementUnitFormCreate";

export function CreateMeasurementUnitForm() {

    return (
        <MeasurementUnitFormCreate/>
    )
}